module.exports = __webpack_public_path__ + "media/images/programming_school_list-a9b749d85630a6245653eb880fb18154.png";